<template>
  <v-card class="modal-principal">
    <v-card-title class="titulo">
      <span>{{titulo}}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-alert
      v-model="alerta.mostrar"
      dismissible
      :type="alerta.tipo"
    >
      {{alerta.mensaje}}
    </v-alert>
    <v-spinner v-if="cargando"></v-spinner>
    <v-card-text
      style="max-height: 100%;"
      v-else
    >
      <v-container grid-list-md>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            sm6
          >
            <v-text-field
              v-model="itemSeleccionado.persona.apellido"
              v-validate="'required|max:50'"
              :error-messages="errors.collect('apellido')"
              label="Apellido"
              data-vv-name="apellido"
              data-vv-validate-on="none"
              required
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            sm6
            d-flex
          >
            <v-text-field
              v-model="itemSeleccionado.persona.nombre"
              v-validate="'required|max:50'"
              :error-messages="errors.collect('nombre')"
              label="Nombre"
              data-vv-name="nombre"
              data-vv-validate-on="none"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            sm12
          >
            <v-text-field
              v-model="itemSeleccionado.email"
              v-validate="'required|email|max:100'"
              :error-messages="errors.collect('email')"
              label="Email"
              data-vv-name="email"
              data-vv-validate-on="none"
              required
              :disabled="soloLectura"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          v-if="!soloLectura"
        >
          <v-flex
            xs12
            sm6
          >
            <v-text-field
              ref="password"
              label="Contraseña"
              v-model="itemSeleccionado.password"
              v-validate="validacion('password')"
              :error-messages="errors.collect('password')"
              data-vv-name="password"
              data-vv-validate-on="none"
              autocomplete="false"
              :append-icon="!hidePassword ? 'visibility' : 'visibility_off'"
              :append-icon-cb="() => (hidePassword = !hidePassword)"
              :type="hidePassword ? 'password' : 'text'"
            ></v-text-field>
          </v-flex>

          <v-flex
            xs12
            sm6
          >
            <v-text-field
              label="Confirmar contraseña"
              v-model="itemSeleccionado.password_confirmation"
              v-validate="validacion('password_confirmation')"
              :error-messages="errors.collect('password_confirmation')"
              data-vv-name="password_confirmation"
              data-vv-validate-on="none"
              autocomplete="false"
              :append-icon="!hidePassword2 ? 'visibility' : 'visibility_off'"
              :append-icon-cb="() => (hidePassword2 = !hidePassword2)"
              :type="hidePassword2 ? 'password' : 'text'"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          v-if="origen === 'abm'"
        >
          <v-flex xs12>
            <v-select
              v-model="itemSeleccionado.roles_seleccionados"
              :items="info.roles"
              :item-text="'name'"
              :item-value="'id'"
              label="Rol"
              attach
              chips
              v-validate="'required'"
              :error-messages="errors.collect('roles')"
              data-vv-name="roles"
              data-vv-validate-on="none"
              :disabled="soloLectura"
            >

            </v-select>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
            sm6
          >
            <v-select
              v-model="itemSeleccionado.persona.documento_identidad.tipo_doc_id"
              :items="info.tiposDocIdentidad"
              :item-text="'nombre'"
              :item-value="'id'"
              label="Tipo Doc."
              v-validate="'required'"
              :error-messages="errors.collect('persona.documento_identidad.tipo_doc_id')"
              data-vv-name="persona.documento_identidad.tipo_doc_id"
              data-vv-validate-on="none"
            ></v-select>
          </v-flex>

          <v-flex
            xs12
            sm6
          >
            <v-text-field
              v-model="itemSeleccionado.persona.documento_identidad.numero"
              v-validate="'required|max:20'"
              :error-messages="errors.collect('persona.documento_identidad.numero')"
              label="Nro documento"
              data-vv-name="persona.documento_identidad.numero"
              data-vv-validate-on="none"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-select
              v-model="itemSeleccionado.instituciones"
              :items="info.instituciones"
              :item-text="nombreInstitucion"
              :item-value="'id'"
              label="Instituciones"
              multiple
              attach
              chips
              v-validate="'required'"
              :error-messages="errors.collect('instituciones')"
              data-vv-name="instituciones"
              data-vv-validate-on="none"
            >

            </v-select>
          </v-flex>
        </v-layout>

      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <botones-cancelar-guardar
        v-bind:mostrar-guardar="puedo(operacion) && !soloLectura"
        v-bind:guardando="guardando"
        v-on:alGuardar="guardar"
        v-on:alCancelar="cerrar"
      ></botones-cancelar-guardar>
    </v-card-actions>
  </v-card>
</template>

<script>
import Combo from '@/api/combo'
import abmFormularioMixin from '@/mixins/abmFormulario'
import _ from 'lodash'

export default {
  name: 'PermisosAbmFormulario',
  mixins: [abmFormularioMixin],
  data () {
    return {
      hidePassword: true,
      hidePassword2: true
    }
  },
  methods: {
    cargarInfo () {
      let vm = this
      let dataCombos = {
        roles: null,
        grupoEntidades: {
          tiposDocIdentidad: {
            codigo: 'tipo_documento'
          }
        },
        instituciones: {}
      }

      Combo.listado(dataCombos).then(data => {
        vm.info = _.assign(vm.info, data)
        vm.cargando = false
      }, error => {
        vm.mostrarError(error)
        vm.soloLectura = true
        vm.cargando = false
      })
    },
    validacion (campo) {
      let validar = ''
      switch (campo) {
        case 'password':
          if (this.operacion === 'modif') {
            validar = 'min:6|max:20'
          } else {
            validar = 'required|min:6|max:20'
          }
          break
        case 'password_confirmation':
          if (this.operacion === 'modif') {
            validar = (this.itemSeleccionado.password ? 'required|' : '') + 'confirmed:password'
          } else {
            validar = 'required|confirmed:password'
          }
          break
        default:
          validar = ''
          break
      }
      return validar
    },
    nombreInstitucion (item) {
      /* if (item.padre) {
        return item.padre.nombre + ' / ' + item.nombre
      } */
      if (item.codigo !== undefined) {
        return item.codigo + ' ' + item.nombre
      } else {
        return item.nombre
      }
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
